<template>
    <vx-card>
        
    </vx-card>
</template>


<script>

/* eslint-disable */
import Select from './components/extra-components/select/Select.vue';
import DatepickerBornDate from './components/extra-components/datepicker/DatepikcerBornDate.vue'

import VxCard from '../components/vx-card/VxCard.vue';
import VxInputGroup from '../components/vx-input-group/VxInputGroup.vue';
import FormsRepository from './forms/e-prevision-forms/forms-repository.vue';
/* eslint-disable */

export default {
	data () {
		return {
            code: "",
            extraProducts: [],
            extraProduct: null,
		}
	},
	components:{
        DatepickerBornDate,
        VxCard,
        VxInputGroup,
        FormsRepository  

	},
	created() {
        this.$vs.loading({ type: "sound" });

        this.code = this.$route.params.code

        // localStorage.clear()

        this.loginAppUser();
        
	},
	methods: {
        loginAppUser() {
            
            const payload = {
                token: process.env.VUE_APP_TOKEN_API
            }

            this.$store.dispatch('auth/loginOauth2', payload)
            .then((response) => {
                if (response.data) {

                    if(this.code){
                        setTimeout(() => this.getExtraProductsByCode(), 500);
                    }

                }
            })
            .catch( error => {
                 this.$vs.loading.close()
                  this.$vs.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getExtraProductsByCode(){
            this.$http.get(process.env.VUE_APP_BROKER_API + '/extra-products-code/' + this.code)
                .then((response) => {
                    if (response.data) {
                        this.extraProduct = response.data;
                        let data = {
                            extraProduct: this.extraProduct
                        }
                        localStorage.setItem( this.code, JSON.stringify(data))
                       
                        this.goToStartProcessExtraProducts(this.code)
                    }
                })
        },


        goToStartProcessExtraProducts() {

            this.$router
            .push("/extra-products/first-step/" + this.code)
            .catch(() => {});
        },
	}
}
</script>

<style lang="scss">

</style>